export const url = process.env.REACT_APP_API_URL || "http://localhost:3000";
export const url_predict = process.env.REACT_APP_API_URL_PREDICT || "http://localhost:5000";